/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTDropdown } from './dropdown';
export type { KTDropdownConfigInterface, KTDropdownInterface } from './types';
